import React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { useData } from './hooks'
import {
  addLeadNote,
  addNoteToPestPac,
  noteCode,
  serviceLocation,
} from '@user/components/Settings/EntityFormSettings/constants'
import { NoteFormFieldElements } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/NoteFormElements'
import { NoteCode } from '@user/components/Notes/typings'

type Props = {
  required: boolean
  hideTitle: boolean
  noteCodes: NoteCode[]
}

export function NoteContent(props: Props) {
  const { required, noteCodes, hideTitle } = props

  const {
    errors,
    touched,
    values,
    serviceOptions,
    submitCount,
    setFieldValue,
  } = useData()

  const externalId = values.externalLocationId

  return (
    <Stack direction="column" width="100%">
      {!hideTitle && (
        <Typography variant="h6" mb={2}>
          Note
        </Typography>
      )}
      <NoteFormFieldElements
        serviceOptions={values.externalLocationId ? serviceOptions : []}
        noteCodes={noteCodes}
        externalLocationId={externalId}
        maxNoteLines={externalId ? 5 : 10}
        noteFieldName={addLeadNote}
        noteFieldHelp={
          submitCount > 0 && errors[addLeadNote] && touched[addLeadNote]
            ? errors[addLeadNote]
            : `${
                values[addLeadNote]
                  ? values[addLeadNote]?.length?.toLocaleString()
                  : 0
              }/5,000`
        }
        noteFieldError={
          submitCount > 0 && errors[addLeadNote] && touched[addLeadNote]
        }
        toggleName={addNoteToPestPac}
        toggleValue={values[addNoteToPestPac]}
        requiredAddNote={required}
        requiredOtherFields={Boolean(values[addLeadNote])}
        serviceLocationHelp={
          errors[serviceLocation] && touched[serviceLocation]
            ? errors[serviceLocation]
            : ''
        }
        serviceLocationError={
          errors[serviceLocation] && touched[serviceLocation]
        }
        noteCodeFieldName={noteCode}
        noteCodeHelp={
          errors[noteCode] && touched[noteCode] ? errors[noteCode] : ''
        }
        noteCodeError={errors[noteCode] && touched[noteCode]}
        selectWidth={'100%'}
        toggleVMargin={3}
        serviceLocationFieldName={serviceLocation}
        noteCode={values.noteCode}
        setFieldValue={setFieldValue}
        serviceLocation={values.serviceLocation}
      />
    </Stack>
  )
}
